// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".student-related-course-item--layout {\n  display: grid;\n  grid-template-columns: 48px 1fr;\n  align-items: flex-start;\n  gap: 20px; }\n  .student-related-course-item--layout img {\n    width: 48px;\n    height: 48px;\n    border-radius: 8px;\n    object-fit: cover; }\n  .student-related-course-item--layout .student-related-course-item--modality {\n    display: flex;\n    align-items: center;\n    gap: 20px; }\n", ""]);
// Exports
module.exports = exports;
